import { Keyboard } from '@capacitor/keyboard';
import { logSentryOnNative } from 'app/core/errors/error-utils';
import ClassName from 'app/styles/ClassName';
import styledFuncs from 'app/styles/styledFuncs';
import styledMixins from 'app/styles/styledMixins';
import clsx from 'clsx';
import React from 'react';
import { css } from 'styled-components/macro';
import { Merge } from 'type-fest';

type Props = Merge<
  React.HTMLProps<HTMLFormElement>,
  {
    margin?: boolean;
    flexStretch?: boolean;
  }
>;

const Form = React.forwardRef<HTMLFormElement, Props>(
  (
    {
      children,
      className,
      margin,
      flexStretch,
      onSubmit,
      ...formProps
    },
    ref
  ) => (
    <form
      className={clsx(
        className,
        ClassName.NO_AUTO_MARGIN,
        'flex flex-col my-0',
        margin ? 'mx-2 max-w-xs' : 'mx-0',
        flexStretch && 'flex-1'
      )}
      onSubmit={evt => {
        evt.preventDefault();
        Keyboard.hide().catch(logSentryOnNative);
        onSubmit?.(evt);
      }}
      css={css`
        ${p =>
          styledMixins.addMarginOnChildrenWithExceptions(
            styledFuncs.pad()(p)
          )}
      `}
      ref={ref}
      {...formProps}
    >
      {children}
    </form>
  )
);

export default Form;
